import DIApi from './_diApi';

class ActivityAPI extends DIApi {
  constructor() {
    super();
  }
  controllerName = 'Activitys';
}

export default new ActivityAPI();
